import { Button, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { usePaymentRule } from "hooks/use-payment-rule";
import { useTranslation } from "react-i18next";
import { PaymentRule } from "types/payment";

const ActivityStepContinueButton = ({ onClick }: { onClick: () => void }) => {
    const paymentRule = usePaymentRule();
    const { data: reservation } = useWebBooking();
    const totalPrice = reservation?.chargeShouldPayAmount;
    const { t } = useTranslation();

    const totalPriceText = t("currency.onlyAmount", {
        value: totalPrice,
        display: "symbol",
    });

    const getButtonText = () => {
        if (paymentRule === PaymentRule.Prepayment) {
            return t("activitySummary.continueToPayment", { totalPriceText });
        }
        return t("activitySummary.continue");
    };
    return (
        <Button
            size="xl"
            w="full"
            onClick={onClick}
            variant="primary"
            p={ThemeSpaceVariable.Small}
            justifyContent="center"
            textAlign="center"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            display="block"
        >
            {getButtonText()}
        </Button>
    );
};

export default ActivityStepContinueButton;
